// ref: https://github.com/07akioni/nuxtjs-naive-ui/issues/4#issuecomment-2194054675

import { setup } from '@css-render/vue3-ssr'

export default defineNuxtPlugin({
  parallel: true,
  setup: nuxtApp => {
    if (import.meta.server) {
      const { collect } = setup(nuxtApp.vueApp)
      nuxtApp.ssrContext!.head.push({
        style: () =>
          collect()
            .split('</style>')
            .map(block => {
              const id = /cssr-id="(.+?)"/.exec(block)?.[1]
              const style = />(.*)/s.exec(block)?.[1]?.trim() ?? ''
              return {
                'cssr-id': id,
                innerHTML: style,
              }
            }),
      })
    }
  },
})
